<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['CATEGORIA', 'SUBCATEGORIAS', 'PA' , $lang.Common.DataTable.Actions]"
            :showNew="true"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inactive ? false : true" :value="obj.nome ? obj.nome.toUpperCase() : ''" />
        <td>
          <ul v-if="obj.subcategoria && obj.subcategoria.filter(sub => sub.inactive !== true).length">
            <li v-for="sub in obj.subcategoria.filter(sub => sub.inactive !== true)" :key="sub.id">
              {{ sub.nome }}
            </li>
          </ul>
          <span v-else>Sem subcategorias</span>
        </td>
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inactive ? false : true" :value="obj.pa ? obj.pa.descricao.toUpperCase() : ''" />
        <td class="text-center">
          <div v-if="obj.inative">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i class="fa fa-lock-open text-secundary icone-grid" style="color: black;" :title="$lang.GroupsConfig.UnlockGroupToolTip"></i>
              </template>
              <b-dropdown-header><strong>{{ $lang.GroupsConfig.ConfirmUnlockGroup }}</strong></b-dropdown-header>
              <b-dropdown-item href="javascript:void(0);" v-on:click="changeGroupStatus(obj, 'false')">{{ $lang.Common.Yes }}</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">{{ $lang.Common.No }}</b-dropdown-item>
            </b-dropdown>
          </div>
          <div v-if="!obj.inative">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i class="fa fa-ban text-secundary icone-grid" style="color: red;" :title="$lang.GroupsConfig.BlockGroupToolTip"></i>
              </template>
              <b-dropdown-header>
                <strong>{{ $lang.GroupsConfig.ConfirmBlockGroup }}</strong>
              </b-dropdown-header>
              <b-dropdown-item href="javascript:void(0);" v-on:click="changeGroupStatus(obj, 'true')">{{ $lang.Common.Yes }}</b-dropdown-item>
              <b-dropdown-item href="javascript:void(0);">{{ $lang.Common.No }}</b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Nova</span></button>
      </div>
    </div>
    <SidebarSearch label="Assunto" @search="onSearch" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import CategoriaRepository from '@/shared/http/repositories/nxSenhas/categoria.js'
import SidebarSearch from '@/views/private/configurations/ajuizamento/SidebarAjuizamento.vue'

export default {
  name: 'CategoriaList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null,
      showModal: false
    }
  },
  components: { SidebarSearch },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      CategoriaRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      CategoriaRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/nxSenhas/categoria/components/list/categoriaList.vue